/**
 * Runner geneli sabitler.
 *
 * PANEL_HOME: runner'dan çıkınca dönülecek yönetici paneli anasayfası.
 * Runner ayrı bir origin (Static Web App) olduğu için tam URL gerekir.
 */
export const PANEL_HOME = "https://app.ecup.me";
